import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/bars-graphs/line-graph/line-graph.js';
      import {ChartDataset} from 'chart.js';
import {XAxisType, YAxisPosition, LineMode, TimeDisplay} from '@oicl/openbridge-webcomponents/dist/building-blocks/chart-line/chart-line-base.js';
import {InstrumentState, Priority, FrameStyle, BorderRadiusPosition} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/types.js';

      export interface Props {
     data?: { label: string; value: number; }[];
     datasets?: ChartDataset<"line", (number | { x: string | number | Date; y: number; })[]>[] | undefined;
     labels?: (string | number)[] | undefined;
     colors?: string[];
     legend?: boolean;
     showDebugOverlay?: boolean;
     width?: number;
     height?: number;
     fixedAspectRatioScaling?: boolean;
     scaleReferenceSize?: number;
     xAxisType?: XAxisType;
     yAxisPosition?: YAxisPosition;
     yAxes?: { id?: string | undefined; position?: "left" | "right" | undefined; min?: number | undefined; max?: number | undefined; grid?: boolean | undefined; }[] | undefined;
     showGrid?: boolean;
     showGridX?: boolean;
     showGridY?: boolean;
     showTickMarks?: boolean;
     showPoints?: boolean;
     lineMode?: LineMode;
     unit?: string;
     timeDisplay?: TimeDisplay;
     xTicksLimit?: number | undefined;
     xStepSize?: number | undefined;
     yTicksLimit?: number | undefined;
     yStepSize?: number | undefined;
     state?: InstrumentState;
     priority?: Priority;
     frameStyle?: FrameStyle;
     borderRadiusPosition?: BorderRadiusPosition | undefined;
     borderRadiusPositionExternalScales?: BorderRadiusPosition | undefined;
     instrumentMode?: boolean;
     borderRadius?: number | undefined
   }

      
  
      export type {ChartDataset} from 'chart.js';
export type {XAxisType, YAxisPosition, LineMode, TimeDisplay} from '@oicl/openbridge-webcomponents/dist/building-blocks/chart-line/chart-line-base.js';
export type {InstrumentState, Priority, FrameStyle, BorderRadiusPosition} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/types.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcLineGraph',
  props: {
    data: {},
    datasets: {},
    labels: {},
    colors: {},
    legend: { type: Boolean },
    showDebugOverlay: { type: Boolean },
    width: {},
    height: {},
    fixedAspectRatioScaling: { type: Boolean },
    scaleReferenceSize: {},
    xAxisType: {},
    yAxisPosition: {},
    yAxes: {},
    showGrid: { type: Boolean },
    showGridX: { type: Boolean },
    showGridY: { type: Boolean },
    showTickMarks: { type: Boolean },
    showPoints: { type: Boolean },
    lineMode: {},
    unit: {},
    timeDisplay: {},
    xTicksLimit: {},
    xStepSize: {},
    yTicksLimit: {},
    yStepSize: {},
    state: {},
    priority: {},
    frameStyle: {},
    borderRadiusPosition: {},
    borderRadiusPositionExternalScales: {},
    instrumentMode: { type: Boolean },
    borderRadius: {}
  },
  setup(__props: any) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-line-graph',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})